import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from '@/components/Icons/ArrowLeft';
import { useScrollFadeProgress } from '@/hooks/useScrollFadeProgress';
import { Layout } from '@/layouts/Layout';
import { Checklist } from '@/pages/Subscription/Intro/Checklist';
import { Features } from '@/pages/Subscription/Intro/Features';
import { StatusCard } from '@/pages/Subscription/Intro/StatusCard';
import { Switchers } from '@/pages/Subscription/Intro/Switchers';
import { goToPreviousPage } from '@/utils/global';

export const SubscriptionIntro: React.FC = () => {
  const { t } = useTranslation();
  const { progress: scrollProgress, handleScroll } = useScrollFadeProgress();

  const mobileHeader = (
    <div className="relative flex w-full items-center md:hidden">
      <button
        type="button"
        onClick={goToPreviousPage}
        aria-label={t('global.back')}
        className="flex size-6 shrink-0 cursor-pointer items-center justify-center text-foreground"
      >
        <ArrowLeft />
      </button>
      <h2
        style={{ opacity: scrollProgress }}
        className="pointer-events-none absolute left-1/2 -translate-x-1/2 text-callout-16 text-foreground"
      >
        {t('subscription.intro.title')}
      </h2>
    </div>
  );

  return (
    <Layout
      disallowPullToRefresh
      hideMobileNavbar
      mobileHeader={mobileHeader}
      onScroll={handleScroll}
    >
      <div className="flex flex-col pb-8 md:px-6 md:pt-6">
        <div className="px-4 md:px-0">
          <h1
            style={{ opacity: 1 - scrollProgress }}
            className="mb-4 pt-1 text-[24px]/[30px] font-semibold text-foreground transition-opacity duration-75 md:hidden"
          >
            {t('subscription.intro.title')}
          </h1>
          <h1 className="mb-4 hidden text-title-24 text-foreground md:block">
            {t('subscription.intro.title')}
          </h1>

          <div className="grid gap-4 md:grid-cols-2">
            <StatusCard />
            <Switchers />
          </div>
        </div>
        <section className="mt-6 overflow-hidden rounded-t-[12px] bg-blue-soft md:mt-8 md:rounded-2xl">
          <Checklist />
          <Features />
        </section>
      </div>
    </Layout>
  );
};
